var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1921.173 1056.445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1,
    x2: 0,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#63c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fadeInBottom",
    x2: "0%",
    y2: "100%"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "black"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "black; #0c9",
    dur: "6s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "black"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "black; #63c",
    dur: "6s",
    fill: "freeze",
    begin: "1s"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    x2: 0,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 0.743,
    x2: 1,
    y2: 0.257,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Banner 2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 400",
    className: "fadeInBottom",
    fill: "none",
    d: "M946.52 628.466a50.926 50.926 0 019.892-.972 50.4 50.4 0 0128.718 8.934m7.956-2.965a57.781 57.781 0 00-52.35-10.956m59.953 8.122a64.925 64.925 0 00-65.533-13.87m72.949 11.107a72.18 72.18 0 00-78.4-16.727m85.669 14.02a79.317 79.317 0 00-91.018-19.53m98.178 16.861a86.482 86.482 0 00-103.465-22.308m110.552 19.667a93.648 93.648 0 00-113.836-26.03m120.864 23.411a100.792 100.792 0 00-125.307-29.2m132.29 26.6a107.939 107.939 0 00-136.371-32.547m143.32 29.958a115.1 115.1 0 00-147.106-36.057M1057.5 609.46a122.277 122.277 0 00-157.97-39.5m164.86 36.931a129.412 129.412 0 00-168.618-43.031m175.493 40.469a136.6 136.6 0 00-179.313-46.55m186.163 44A143.729 143.729 0 00888.1 551.733m196.857 47.493a150.9 150.9 0 00-199.707-54.088m206.54 51.543a158.075 158.075 0 00-210.223-57.693",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.815
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Linha 28",
    d: "M1138.008 579.109l-169.807 63.279"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 401",
    d: "M467.423 387.158v34.1L496.95 438.3l29.528-17.048v-34.1l-29.528-17.041z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "moveOnMouse",
    "data-name": "Grupo 68",
    fill: "none",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 402",
    d: "M0 788.33l229.4 218.978 1347.766-163.732L1776.1 683.185l143.9-79.249"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 403",
    d: "M0 772.563L239.717 990.2l1324.195-150.247 207.33-161.793L1920 601.936"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 404",
    d: "M0 756.8l250.029 216.283L1550.658 836.33l215.722-163.2L1920 599.936"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 405",
    d: "M0 741.03l260.341 214.941L1537.4 832.706l224.113-164.6L1920 597.935"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 406",
    d: "M0 725.263l270.653 213.6 1253.5-109.776 232.505-166L1920 595.935"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 407",
    d: "M0 709.5l280.965 212.25L1510.9 825.46l240.9-167.4 168.2-64.125"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 408",
    d: "M0 693.73l291.277 210.9 1206.365-82.8 249.289-168.8L1920 591.935"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 409",
    d: "M0 677.964l301.59 209.558 1182.8-69.309 257.681-170.206L1920 589.935"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 410",
    d: "M0 662.2l311.9 208.21 1159.233-55.82 266.073-171.608L1920 587.935"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 411",
    d: "M0 646.43L322.214 853.3l1135.667-42.331 274.464-173.01L1920 585.934"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 412",
    d: "M0 630.664l332.526 205.521 1112.1-28.842 282.856-174.412 192.517-49"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 413",
    d: "M0 614.9l342.838 204.173 1088.535-15.353 291.248-175.814L1920 581.934"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 414",
    d: "M0 599.131L353.15 801.96l1064.969-1.86 299.64-177.216L1920 579.934"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 415",
    d: "M0 583.364l363.462 201.484 1041.4 11.625L1712.9 617.855l207.1-39.921"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 416",
    d: "M0 567.6l373.774 200.136 1017.838 25.114 316.423-180.02L1920 575.933"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 417",
    d: "M0 551.831l384.086 198.792 994.272 38.6L1703.173 607.8 1920 573.933"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 418",
    d: "M0 536.064l394.4 197.447 970.7 52.089 333.207-182.824L1920 571.933"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 419",
    d: "M0 520.3l404.71 196.1 947.14 65.581 341.6-184.226L1920 569.933"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 420",
    d: "M0 504.531l415.023 194.756 923.574 79.07 349.991-185.629L1920 567.933"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 421",
    d: "M0 488.764l425.335 193.41 900.008 92.559L1683.725 587.7 1920 565.932"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 422",
    d: "M0 473l435.647 192.062 876.442 106.048 366.774-188.433L1920 563.932"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 423",
    d: "M0 457.231L445.959 647.95l852.876 119.537L1674 577.652l246-15.719"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 424",
    d: "M0 441.465l456.271 189.372 829.31 133.026 383.558-191.237L1920 559.932"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 425",
    d: "M0 425.7l466.583 188.025 805.744 146.515 391.95-192.64L1920 557.932"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 426",
    d: "M0 409.932l476.9 186.681 782.178 160 400.342-194.041 260.58-6.64"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 427",
    d: "M0 394.165L487.207 579.5l758.612 173.493 408.734-195.443L1920 553.931"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 428",
    d: "M0 378.4l497.519 183.99 735.047 186.98 417.125-196.845 270.309-.594"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 429",
    d: "M0 362.632l507.831 182.644 711.48 200.471L1644.829 547.5 1920 549.931"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 430",
    d: "M0 346.865l518.143 181.3 687.914 213.96 433.909-199.649L1920 547.931"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 431",
    d: "M0 331.1l528.456 179.951L1192.8 738.5l442.3-201.051 284.9 8.482"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 432",
    d: "M0 315.332l538.768 178.607 640.782 240.937 450.693-202.453L1920 543.93"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 433",
    d: "M0 299.565l549.08 177.262 617.22 254.426L1625.381 527.4 1920 541.93"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 434",
    d: "M0 283.8l559.392 175.914 593.65 267.916 467.476-205.258L1920 539.93"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 435",
    d: "M0 268.032L569.7 442.6 1139.785 724l475.868-206.66L1920 537.93"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 436",
    d: "M0 252.266L580.016 425.49l546.519 294.893 484.26-208.062L1920 535.93"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 437",
    d: "M0 236.5l590.328 171.877 522.953 308.383 492.652-209.46L1920 533.93"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 438",
    d: "M0 220.732l600.64 170.533 499.387 321.871 501.044-210.866L1920 531.929"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 439",
    d: "M0 204.966l610.952 169.187 475.821 335.36 509.435-212.268L1920 529.929"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 440",
    d: "M0 189.2l621.264 167.84 452.255 348.85 517.827-213.67L1920 527.929"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 441",
    d: "M0 173.433l631.576 166.5 428.689 362.338 526.219-215.072L1920 525.929"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 442",
    d: "M0 157.666l641.889 165.15 405.123 375.827 534.611-216.474L1920 523.929"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 443",
    d: "M0 141.9l652.2 163.8 381.558 389.32 543-217.876L1920 521.928"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 444",
    d: "M0 126.133l662.513 162.458L1020.5 691.4l551.4-219.282 348.1 47.81"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 445",
    d: "M0 110.366l672.825 161.113 334.425 416.294 559.786-220.68L1920 517.928"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 446",
    d: "M0 94.6l683.137 159.766L994 684.15l568.178-222.082L1920 515.928"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 447",
    d: "M0 78.833l693.449 158.421 287.293 443.272 576.57-223.485L1920 513.928"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 448",
    d: "M0 63.066l703.761 157.076L967.489 676.9l584.961-224.884L1920 511.927"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 449",
    d: "M0 47.3l714.073 155.73 240.162 470.25 593.354-226.289L1920 509.927"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 450",
    d: "M0 31.533l724.385 154.384 216.6 483.739 601.746-227.691L1920 507.927"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 451",
    d: "M0 15.767L734.7 168.8l193.03 497.228 610.134-229.088L1920 505.927"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 452",
    d: "M0 0l745.009 151.693L914.473 662.41 1533 431.915l387 72.012"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 454",
    className: "fadeIn",
    d: "M1463.143 702.254v76.214h76.214v-76.214zm57.161 57.16H1482.2v-38.107h38.1z",
    transform: "translate(71.931 109.931)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 40",
    cx: 18.52,
    cy: 18.52,
    r: 18.52,
    transform: "translate(407.852 740.552)",
    fill: "#202020",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 71"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 41",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(838.301 1007.308)",
    fill: "none",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 42",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(471.871 48.014)",
    fill: "none",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 43",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(307.447 586.778)",
    fill: "none",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 44",
    cx: 17.519,
    cy: 17.519,
    r: 17.519,
    transform: "translate(55.889 943.776)",
    fill: "none",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 45",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(886.65 355.291)",
    fill: "none",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 48",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(1113.659 298.622)",
    fill: "none",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 49",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(1716.567 933.172)",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 50",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(1702.786 1044.862)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 51",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(1647.264 1034.259)",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 52",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(1695.789 985.733)",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 53",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(1021.531 726.209)",
    fill: "none",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "pulsating"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 72"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 54",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(752.859 936.251)",
    fill: "none",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 55",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(222.006 515.721)",
    fill: "none",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 56",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(801.208 284.233)",
    fill: "none",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 57",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(1436.957 300.139)",
    fill: "none",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 59",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(1028.217 227.564)",
    fill: "none",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 60",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(1631.125 862.115)",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 61",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(1667.442 978.058)",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 62",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(1652.565 912.281)",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 63",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(1681.291 832.973)",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 64",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(936.09 655.151)",
    fill: "none",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "pulsating"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 73"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 65",
    cx: 10.603,
    cy: 10.603,
    r: 10.603,
    transform: "translate(98.406 695.951)",
    fill: "#333",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 66",
    cx: 10.603,
    cy: 10.603,
    r: 10.603,
    transform: "translate(822.396 141.089)",
    fill: "#202020",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 68",
    cx: 7.447,
    cy: 7.447,
    r: 7.447,
    transform: "translate(661.156 613.619)",
    fill: "#333",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 70",
    cx: 14.868,
    cy: 14.868,
    r: 14.868,
    transform: "translate(1344.368 943.776)",
    fill: "none",
    stroke: "#191919",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "pulsating"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 74",
    className: "fadeInCube"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 570"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 455",
    d: "M410.1 365.619v123.392l106.86 61.7 106.86-61.7V365.619l-106.86-61.7z",
    fill: "url(#linear-gradient)",
    transform: "translate(-20.013 -23.109)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 456",
    d: "M435.729 368.86v70.692l61.221 35.351 61.221-35.346V368.86l-61.221-35.346z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.297 404.432l52.24-30.023v60.184l-52.24 30.158z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.322 371.275l52.361-30.231 52.361 30.231-52.361 30.092z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.828 433.593v-60.184l52.24 30.023v60.321z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 457",
    stroke: "#000",
    d: "M411.514 354.88v98.654l85.432 49.327 85.436-49.327V354.88l-85.436-49.326z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: "2 5"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 75",
    className: "pulsating",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Linha 49",
    d: "M161.409 201.32h81.568"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Linha 50",
    d: "M202.193 242.104v-81.568"
  })), /*#__PURE__*/React.createElement("g", {
    className: "pulsating",
    "data-name": "Grupo 77",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.718
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Linha 53",
    d: "M1761.902 745.292h28.403"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Linha 54",
    d: "M1776.103 759.493V731.09"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 78",
    fill: "none",
    stroke: "#202020",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Linha 55",
    d: "M1474.05 340.386h21.225",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 458",
    d: "M1484.662 351l10.612-10.612-10.612-10.612",
    className: "pulsating"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 95",
    className: "pulsating"
  }, /*#__PURE__*/React.createElement("g", {
    className: "pulsating",
    "data-name": "Grupo 82"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 81"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 71",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(827.697 123.784)",
    fill: "#202020"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 84"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 83"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 72",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(847.276 135.087)",
    fill: "#202020"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 86"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 85"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 73",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(847.276 157.695)",
    fill: "#202020"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 88"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 87"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 74",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(827.697 168.998)",
    fill: "#202020"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 90"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 89"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 75",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(808.119 157.695)",
    fill: "#202020"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 92"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 91"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 76",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(808.119 135.087)",
    fill: "#202020"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 94"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 93"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 77",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(827.697 123.784)",
    fill: "#202020"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 98",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    className: "pulsating"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Linha 63",
    d: "M801.017 792.185h39.556"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Linha 64",
    d: "M820.794 811.963v-39.556",
    className: "pulsating"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 39",
    d: "M1242.735 636.427h25.982v25.982h-25.982z",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 40",
    d: "M602.739 727.561h25.982v25.982h-25.982z",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 41",
    d: "M444.404 188.329h25.982v25.982h-25.982z",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 42",
    d: "M1699.559 535.794h12.991v12.991h-12.991z",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 43",
    d: "M1766.054 602.965h12.991v12.991h-12.991z",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 44",
    d: "M1598.054 636.427h25.982v25.982h-25.982z",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 45",
    d: "M1802.149 513.343h12.991v12.991h-12.991z",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 46",
    d: "M1874.799 542.29h12.991v12.991h-12.991z",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 47",
    d: "M1001.609 823.764h12.991v12.991h-12.991z",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 48",
    d: "M1521.205 500.443h12.991v12.991h-12.991z",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 49",
    d: "M1420.906 631.733h36.859v36.859h-36.859z",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 461",
    d: "M119.613 465.735v34.1l29.528 17.048 29.528-17.048v-34.1l-29.529-17.048z",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 462",
    d: "M213.589 756.2v49.375l42.76 24.687 42.76-24.687V756.2l-42.76-24.687z",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 463",
    d: "M876.306 776.06v31.8l27.542 15.9 27.542-15.9v-31.8l-27.542-15.9z",
    className: "pulsating"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 50",
    transform: "translate(0 429.024)",
    fill: "url(#c)",
    d: "M0 0h202.193v9.871H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 51",
    transform: "translate(0 399.272)",
    fill: "url(#c)",
    d: "M0 0h202.193v9.871H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 52",
    transform: "translate(0 369.52)",
    fill: "url(#c)",
    d: "M0 0h202.193v9.871H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainSvg);
export default __webpack_public_path__ + "static/media/mainSvg.c81580bdbfc6fd9c1fe44a4ba6e46ce4.svg";
export { ForwardRef as ReactComponent };